<template>
  <div class="bind-form">
    <div class="form-content">
      <div class="form-item">
        <span class="label">持卡人</span>
        <div class="input-wrap">{{ bankInfo.name }}</div>
      </div>
      <div class="form-item">
        <span class="label">身份证号</span>
        <div class="input-wrap">{{ bankInfo.id_card }}</div>
      </div>
      <div class="form-item">
        <span class="label">银行卡号</span>
        <div class="input-wrap">{{ bankInfo.bank_card }}</div>
      </div>
      <div class="form-item">
        <span class="label">所属银行</span>
        <div class="input-wrap">{{ bankInfo.bank_name }}</div>
      </div>
      <div class="form-item">
        <span class="label">预留手机号</span>
        <div class="input-wrap">{{ bankInfo.phone }}</div>
      </div>
    </div>
    <div class="btn-confirm" @click="$router.push({ name: 'bindForm' })">
      修改银行卡信息
    </div>
  </div>
</template>

<script>
import { getBankInfo } from '@/api/income';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['bankInfo']),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 绑定成功后更新数据
      if (this.$route.params.update) {
        this.fetchKfzInfo();
      }
    },
    //存储更新后的银行卡信息
    async fetchKfzInfo() {
      try {
        const res = await getBankInfo();
        this.$store.commit('SET_BANK_INFO', res.data);
      } catch (error) {
        console.log('error');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bind-form {
  font-size: 24px;
  color: #262626;
  width: 100%;
  min-height: calc(100vh - 103px);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .form-content {
    margin-top: 78px;
    .form-item {
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 50px;
      width: 560px;
      .label {
        flex: 1;
        text-align: right;
        margin-right: 28px;
        font-size: 26px;
      }
      .input-wrap {
        width: 400px;
        line-height: 56px;
        height: 56px;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        text-indent: 15px;
      }
    }
  }
  .btn-confirm {
    width: 500px;
    height: 70px;
    background: #fd9b21;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    line-height: 70px;
    font-size: 28px;
    margin-top: 202px;
  }
}
</style>
